import React from 'react';

// Helper to render stars
const Stars = ({ count = 5 }) => (
  <div className="flex items-center mb-1">
    {Array.from({ length: count }).map((_, i) => (
      <svg
        key={i}
        className="w-4 h-4 text-yellow-400 mr-1"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.955L10 0l2.951 5.955 6.561.955-4.756 4.635 1.122 6.545z" />
      </svg>
    ))}
  </div>
);

const BlockTestimonial = ({ block, className = '', isEditing, settingsFunnel }) => {
  // Fallback/test data if block.data is missing

  if(!block.testimonials){
    block.testimonials = [
        {
            src: '',
            name: 'Pedro Cardoso',
            social: '@lorem.ispum',
            feedback: 'Tellus in risus sagittis condimentum',
            stars: 5,
            },
            {
                src: '',
                name: 'Pedro Cardoso',
                social: '@lorem.ispum',
                feedback: 'Tellus in risus sagittis condimentum',
                stars: 5,
                },
        ];
    }


  // Determine style: "list" (default) or "grid"
  const style = block.style || block.data?.style || "list";

  if (style === "grid") {
    // Grid layout
    return (
      <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 w-full ${className}`}>
        {block.testimonials.map((t, idx) => (
          <div
            key={idx}
            className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col items-center text-center"
          >
            {t.src ? (
              <img src={t.src} alt={t.name} className="w-14 h-14 rounded-full mb-2" />
            ) : null}
            <Stars count={t.stars} />
            <div className="font-bold text-gray-900 text-lg leading-tight">{t.name}</div>
            <div className="text-gray-400 text-sm mb-1">{t.social}</div>
            <div className="text-gray-500 text-base">{t.feedback}</div>
          </div>
        ))}
      </div>
    );
  }

  // Default: list layout
  return (
    <div className={`flex flex-col gap-3 w-full ${className}`}>
      {block.testimonials.map((t, idx) => (
        <div
          key={idx}
          className="border border-gray-300 flex flex-row shadow-sm rounded-xl p-4 w-full"
        >
          <div className="flex flex-row items-center gap-2">
            {t.src ? (
              <div className="flex flex-col items-center gap-2">
                <img src={t.src} alt={t.name} className="w-10 h-10 rounded-full" />
              </div>
            ) : null}

            <div className="flex flex-col gap-2">
              <Stars count={t.stars} />
              <div className="font-bold text-gray-900 leading-tight" style={{fontSize: '14px', pointerEvents: 'none'}}>{t.name}</div>
              
              {t.social ? <div className="text-gray-400 text-sm mb-1">{t.social}</div> : null}
              <div className="text-gray-500 " style={{color: settingsFunnel.textColor, fontSize: '12px', pointerEvents: 'none'}}>{t.feedback}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlockTestimonial;